export const DATAFETCH = 'DATAFETCH';
export const ADDMODAL = 'ADDMODAL';
export const REMOVEMODAL = 'REMOVEMODAL';
